import { useCallback } from "react"
import { initializeErrors } from "../reducer/validationSlice"
import validate from "validate.js"
import { createValidationStructure } from "../../../../src/components/Helper"

export const useInitializeHeaderValidations = (tabName,validationPattern) => {

  
    const headerTabValidatonInit = useCallback(() => (dispatch, getState) => {
            const headerTab = getState().headerReducer?.headerTab
            let errors = validate(headerTab,validationPattern()?.[tabName]) || {}
            errors = createValidationStructure(errors)
            dispatch(initializeErrors({headerTab:errors}))
    }, [])

   

    return { headerTabValidatonInit }
}